import { render } from "./ContractJsonView.vue?vue&type=template&id=47d9ea77"
import script from "./ContractJsonView.vue?vue&type=script&lang=js"
export * from "./ContractJsonView.vue?vue&type=script&lang=js"

import "./ContractJsonView.vue?vue&type=style&index=0&id=47d9ea77&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__